import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Department } from '../../models/department';
import { DepartmentService } from '../../services/department.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { take, takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { Committee } from '../../models/committee';
import { CommitteeService } from '../../services/committee.service';
import { DatePipe } from '@angular/common';
import { BasicMaster } from '../../models/basicmaster';
import { BasicMasterService } from '../../services/basicmaster.service';
import { dateFieldName, toString } from '@progress/kendo-angular-intl';
import { committeemember } from '../../models/committeemember';
import { Alert } from 'selenium-webdriver';
import { committeeReviewer } from '../../models/committeeReviewer';
import { FileUploaderService } from '../../services/fileuploader.service';
import { MeetingtypeService } from '../../services/meetingtype.service';
import { Meetingtype } from '../../models/meetingtype';
import { InviteeType } from '../../models/inviteetype';
import { InviteeTypeService } from '../../services/inviteetype.service';
import { Act } from '../../models/act';
import { ActService } from '../../services/act.service';
import { committeepermenantInvitees } from '../../models/committeepermenantInvitees';
import { DateService } from '../../services/date.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { threadId } from 'worker_threads';
import { committeesecratary } from '../../models/committeesecratary';
import { committeeChairman } from '../../models/committeechairman';
import { DocumentServerService } from '../../services/documentdownload.Service';
// import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-committee',
  // standalone: true,
  // imports: [NgbNavModule],
  templateUrl: './committee.component.html',
  styleUrls: ['./committee.component.css'],

})
export class CommitteeComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('excelexport1', { static: false }) excelexport1!: ExcelExportComponent;
  @ViewChild('excelexport2', { static: false }) excelexport2!: ExcelExportComponent;
  @ViewChild('excelexport3', { static: false }) excelexport3!: ExcelExportComponent;
  @ViewChild('excelexport4', { static: false }) excelexport4!: ExcelExportComponent;

  @ViewChild('view') view!: TemplateRef<any>;
  active = 1;
  private unsubscribe$: Subject<void> = new Subject<void>();

  headerCommittee: PageHeader;
  entity: Committee = new Committee();
  committeememberentity: committeemember = new committeemember();
  committeeReviewerentity: committeeReviewer = new committeeReviewer();
  committeepermenantInviteesentity: committeepermenantInvitees = new committeepermenantInvitees();

  selectedcommittee: Committee = new Committee();
  // selectedemployee: Employee = new Employee();
  editingEntity: Committee = new Committee();
  committee: any;
  committeemember: any;
  CommitteeColumns: any[] = [];
  SecretaryColumns: any[] = [];
  chairmanColumns: any[] = [];
  MemberColumns: any[] = [];
  permenantInviteesgridcolumns: any[] = [];
  ReviewerColumns: any[] = [];
  actColumns: any[] = [];
  organizerColumns: any[] = [];
  multidepartmentColumns: any[] = [];
  listView: boolean = true;
  ShowTab1: boolean = false;
  ShowTab2: boolean = false;
  ShowTab3: boolean = false;
  ShowTab4: boolean = false;
  ShowTab5: boolean = false;
  formCaption: string = '';
  locations: Array<Location> = [];
  selectedLocation: any;
  _selectedDepartment: any;
  _selectedcommittee: any;
  _selectedInvitee: any;
  _selectedOrganizer: Array<Employee> = [];
  _selectedMultidept: Array<Department> = [];
  _selectedAct: any;
  Secratary_employees: Array<Employee> = [];
  Chairman_employees: Array<committeemember> = [];
  // PermenantInvitees: Array<Employee> = [];
  selected_members: Array<committeemember> = [];
  selected_Invitees: Array<committeepermenantInvitees> = [];
  selected_acts: Array<Act> = [];
  member_employees: Array<Employee> = [];
  Invitees_employees: Array<Employee> = [];
  selectedEmployee: any;
  selectedChairman: any;
  selectedMember: any;
  addedmember: any;
  selectedInvitees: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  secretaryadddisabled: boolean = false;
  departments: Array<Department> = [];
  pipe = new DatePipe('en-US');
  basicmaster: Array<BasicMaster> = [];
  selectedQuorum: any;
  Memberarray: any = [];
  Inviteesarray: any = [];
  Secretaryarray: any = [];
  Chairmanarray: any = [];
  Reviewerarray: any = [];
  Meetingtype: Array<Meetingtype> = [];
  flag: any = 0;
  selectedmeeting: any;
  path: string = "";
  fileName: string = "";
  url = '';
  Inviteetype: Array<InviteeType> = [];
  organizerdata: Array<Employee> = [];
  multidepartmentdata: Array<Department> = [];
  actdata: Array<Act> = [];
  Employee_inviteedata: Array<Employee> = [];
  mappingentity: Committee = new Committee();
  membermappingentity: committeemember = new committeemember();
  committeememberdata: Array<committeemember> = [];
  organizer_list!: any[];
  dept_list!: any[];
  act_list!: any[];
  Invitees_list!: any[];
  isButtonVisible: boolean = false;
  public showTenure: boolean = false;
  public showDate: boolean = false;
  public showTenurePerm: boolean = false;
  public showDatePerm: boolean = false;
  public showsittingfee: boolean = false;

  public showDateMember: boolean = false;
  public showTenureMember: boolean = false;
  public showDateChairman: boolean = false;
  public showTenureChairman: boolean = false;
  public showpermanenttab: boolean = true;
  public showchairmantab: boolean = true;
  selecteddetails: any;
  // public generaltab: boolean = true;
  // public membertab: boolean = true;
  // public secretarytab: boolean = true;
  // public Chairmantab: boolean = true;
  // public permanenttab: boolean = true;
  // public meme: boolean = false;
  public isChecked: boolean = false;
  aciveTab: number = 0;
  opened: boolean = false;
  details: any;
  MemberId: string = "";
  SecretaryId: string = " ";
  ChairmanId: string = "";
  InviteeId: string = "";
  memberCaption: string = '';
  PermanentCaption: string = '';
  OrganizerCaption: string = '';
  MultiDepartmentCaption: string = '';
  actCaption: string = '';
  memberdisabled: boolean = true;
  secretarydisabled: boolean = true;
  chairmandisabled: boolean = true;
  permanentdisabled: boolean = true;
  selectedMemberEmp: Employee | null = null;
  selectedInviteeEmp: Employee | null = null;
  selectedSecretaryEmp: Employee | null = null;
  selectedChairmanEmp: Employee | null = null;
  // selectedSecreatary: Employee | null = null;
  EditCommitteeMemberArray: Array<committeemember> = [];
  EditCommitteePerInvArray: Array<committeepermenantInvitees> = [];
  groups: any;
  download:any;
  isDownloadButtonVisible: boolean = false;
  constructor(
    private _departmentService: DepartmentService,
    private _committeeService: CommitteeService,
    private _locationService: LocationService,
    private _employeeService: EmployeeService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private _basicMasterService: BasicMasterService,
    private fileUploader: FileUploaderService,
    private _MeetingtypeService: MeetingtypeService,
    private _InviteeTypeService: InviteeTypeService,
    private _actservice: ActService,
    private dateService: DateService,
    private router: Router,
    private documentdownloadservice: DocumentServerService,

  ) {
    this.headerCommittee = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.committee = [];
    this.getAllCommittee();
  }

  ngAfterViewInit(): void {

    this.CommitteeColumns = [
      { field: "SlNo", title: 'Sl No.', filter: false, sortable: true, width: 50 },
      { field: "CommitteeName", title: 'Meeting Type', filter: true, sortable: true, width: 100 },
      { field: "ShortName", title: 'Code', filter: true, sortable: true, width: 70 },
      { field: "MeetingTypeName", title: 'Meeting Group', filter: true, sortable: true, width: 100 },
      { field: "DepartmentName", title: 'Organising Department', filter: true, sortable: true, width: 100 },
      { field: "FormationDate", title: 'Date of Formation', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];

    this.SecretaryColumns = [
      { field: "SecretaryName", title: 'Secretary', filter: true, sortable: true },
      { field: "SecretaryJoiningDateStr", title: 'Joining Date', filter: true, sortable: true },
      { field: "SecretaryInChargeTillDateStr", title: 'In Charge Till Date', filter: true, sortable: true },
      { field: "SecretaryTenureDate", title: 'Tenure Date ', filter: true, sortable: true },
      // { field: "SecretaryEditBit", title: 'SecretaryEditBit', filter: true, sortable: true },
    ];

    this.chairmanColumns = [
      { field: "ChairmanName", title: 'Chairman', filter: true, sortable: true },
      { field: "ChairmanJoiningDatestr", title: 'Joining Date', filter: true, sortable: true },
      { field: "ChairmanInChargeTillDatestr", title: 'In Charge Till Date', filter: true, sortable: true },
      { field: "Till", title: 'Tenure Date ', filter: true, sortable: true }
    ];

    this.permenantInviteesgridcolumns = [
      { field: "EmployeeName", title: 'Employee', filter: true, sortable: true },
      //{ field: "DesignationName", title: 'Designation', filter: true, sortable: true },
      { field: "PermenantInviteeJoiningDateStr", title: 'Joining Date', filter: true, sortable: true },
      { field: "PermenantInviteeInChargeTillDateStr", title: 'In Charge Till Date', filter: true, sortable: true },
      { field: "TenureDatePerm", title: 'Tenure Date ', filter: true, sortable: true }
    ];

    this.MemberColumns = [
      { field: "EmployeeName", title: 'Member', filter: true, sortable: true },
      { field: "JoiningDateStr", title: 'Joining Date', filter: true, sortable: true },
      { field: "MembershipExpiryDateStr", title: 'InCharge Till Date', filter: true, sortable: true },
      { field: "MemberInChargeTillTenureDate", title: 'In Charge Tenure Date ', filter: true, sortable: true },
      { field: "SittingFee", title: 'Sitting Fee', filter: true, sortable: true },
      { field: "SittingFeeEffectiveFromStr", title: 'Effective From', filter: true, sortable: true },
      { field: "SittingFeeEffectiveToStr", title: 'Effective To', filter: true, sortable: true },
      // { field: "MemberEditBit", title: 'MemberEditBit', filter: true, sortable: true },
    ];
    this.ReviewerColumns = [
      {
        cellTemplate: '<input type="checkbox" ng-model="row.entity.Emp_Ref_Id" ng-click="toggle(row.entity.EmployeeName,row.entity.Emp_Ref_Id)">'
      },
      { field: "EmployeeName", title: 'Employee Name', filter: true, sortable: true },
      { field: "DesignationName", title: 'Designation', filter: true, sortable: true },
      { field: "DepartmentName", title: 'Organizing Department', filter: true, sortable: true },
    ];
    this.actColumns = [
      // { field: "SlNo", title: 'SL No', filter: true, sortable: true, width: 70 },
      { field: "ActName", title: 'Act Name', filter: true, sortable: true, width: 100 },
    ];
    this.organizerColumns = [
      { field: "UserName", title: 'Organizer Name', filter: true, sortable: true, width: 100 },
    ];
    this.multidepartmentColumns = [
      { field: "DepartmentName", title: 'Department', filter: true, sortable: true, width: 100 },
    ];
  }


  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._committeeService.getAllCommittee('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, '').subscribe((entities: Array<Committee>) => {
      this.committee = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  SecretaryRadios1(event: any) {
    this.entity.isChecked = true;
    this.showTenure = false;
    this.showDate = true;
    this.entity.SecretaryInChargeTill_Id = 1

  }
  SecretaryRadios2(event: any) {
    this.entity.isChecked = false;
    this.showTenure = true;
    this.showDate = false;
    this.entity.SecretaryInChargeTill_Id = 2;

  }
  permInvChangeradio1(event: any) {
    this.entity.isChecked = true;
    this.entity.PermenantInviteeInChargeTill_Id = 1
    this.showTenurePerm = false;
    this.showDatePerm = true;
  }
  permInvChangeradio2(event: any) {
    this.entity.isChecked = false;
    this.entity.PermenantInviteeInChargeTill_Id = 0;
    this.showTenurePerm = true;
    this.showDatePerm = false;
  }

  MemberRadios1(event: any) {
    this.entity.isChecked = true;
    this.entity.MemberInChargeTill_Id = 1;
    this.showTenureMember = false;
    this.showDateMember = true;
  }
  MemberRadios2(event: any) {
    this.entity.isChecked = false;
    this.entity.MemberInChargeTill_Id = 0;
    this.showTenureMember = true;
    this.showDateMember = false;
  }

  ChairmanRadios1(event: any) {
    this.entity.isChecked = true;
    this.showTenureChairman = false;
    this.showDateChairman = true;
    this.entity.ChairmanInChargeTill_Id = 1
  }
  ChairmanRadios2(event: any) {
    this.entity.isChecked = false;
    this.showTenureChairman = true;
    this.showDateChairman = false;
    this.entity.ChairmanInChargeTill_Id = 2
  }
  getAllLocations(filter: string) {
    this._locationService.getAllLocations(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Location>) => {
      this.locations = data;
    })
  }
  getAllEmployee_reviewer(filter: string) {
    var filter = ('DepartmentName|' + this.entity.reviewrDepartmentName + ';');
    this._employeeService.getAllEmployees(filter, this.defaultRowsCount, 1, 1, 0).subscribe((data: Array<Employee>) => {
      this.Reviewerarray = data;
    })
  }

  getAllQuorumOptions(filter: string) {
    this._basicMasterService.getBasicMastersByName('QuorumOptions', filter, this.defaultRowsCount, 1).subscribe((data: Array<BasicMaster>) => {
      this.basicmaster = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._committeeService.getAllCommittee(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, '').subscribe((committee: Array<Committee>) => {
        this.committee = {
          data: committee,
          total: committee[0] ? committee[0].TotalCount : 0
        }
      });
    }
  }
  getAllCommittee() {
    this._committeeService.getAllCommittee('', Number(this.defaultPageSize), 1, 0, '').subscribe((committee: Array<Committee>) => {
      this.committee.DateOfFormation = new Date(this.committee.DateOfFormation);
      this.committee = committee;
      // for (let i = 0; i < committee.length; i++) {
      //   this.committee[i].FormationDate = this.pipe.transform(this.committee[i].DateOfFormation, "dd/MM/yyyy");
      // }
      this.committee = {
        data: committee,
        total: committee[0] ? committee[0].TotalCount : 0
      }
    })
  };
  clearChairman() {
    this.Chairmanarray = [];
    this.selectedChairman = {};
    // this.entity.ChairmanName='';
    this.entity.Chairman_Emp_Ref_Id = '00000000-0000-0000-0000-000000000000';
    this.entity.ChairmanJoiningDate = undefined;
    this.entity.ChairmanInChargeTillTenure = 0;
    this.entity.ChairmanInChargeTillDate = undefined;
  }
  clearSecretary() {
    // this.RemoveElementFromObjectSecretaryArray(this.entity.Secretary_Emp_Ref_Id);
    this.Secretaryarray = [];
    this.selectedEmployee = {};
    this.entity.Secretary_Emp_Ref_Id = '00000000-0000-0000-0000-000000000000';
    // this.entity.SecretaryName= '';
    this.entity.SecretaryJoiningDate = undefined;
    this.entity.SecretaryInChargeTillTenure = 0;
    this.entity.SecretaryInChargeTillDate = undefined;

    //this.committeesecretary = new committeesecratary();
  }
  clearMember() {
    this.Memberarray = [];
    this.selectedMember = {};
    this.committeememberentity = new committeemember();
  }
  clearPermenant() {
    this.Inviteesarray = [];
    this.selectedInvitees = {};
    this.committeepermenantInviteesentity = new committeepermenantInvitees();
  }
  getval_chairman() {
    this.Chairmanarray = [];
    this.saveDisabled = false;
    var joining_date: any;
    let chairman_exipirydate: any;
    var data = [... this.Chairmanarray];

    var employeeCheck = this.entity.Chairmanarray.filter(
      Chairmanarray => Chairmanarray.ChairmanEditBit === 1);

    if (employeeCheck.length == 1) {
      var editchairman = this.entity.Chairmanarray.filter(
        editemployees => editemployees.ChairmanEditBit === 1);

      var editemp = this.entity.Chairmanarray.filter(
        editemps => editemps.Emp_Ref_Id === this.Chairmanarray.Emp_Ref_Id && editemps.ChairmanEditBit != 1);
      if (editemp.length > 0) {
        this.notification.showWarning('Permanent Invitee Already Exists');
      }
      else {
        joining_date = this.convertdate(this.entity.ChairmanJoiningDate);
        chairman_exipirydate = (this.entity.ChairmanInChargeTillDate == null || new Date(this.entity.ChairmanInChargeTillDate).getFullYear() == 1900) ? '' : this.entity.ChairmanInChargeTillDate;

        let TenureDateChairmanstr = null;
        if (this.entity.ChairmanInChargeTillTenure > 0) {
          let date = this.entity.ChairmanJoiningDate != undefined ? this.entity.ChairmanJoiningDate.setDate(this.entity.ChairmanJoiningDate.getDate() + (365 * this.entity.ChairmanInChargeTillTenure)) : undefined;
          let datePipe: DatePipe = new DatePipe('en-US');
          TenureDateChairmanstr = datePipe.transform(date, 'dd/MM/yyyy');
        }
        this.showDateChairman = false;
        this.showTenureChairman = false;
        editchairman[0].Committee_Id = this.entity.Committee_Id,
          editchairman[0].ChairmanJoiningDatestr = this.pipe.transform(this.convertdate(joining_date), "dd/MM/yyyy");
        editchairman[0].ChairmanJoiningDate = joining_date;
        editchairman[0].ChairmanInChargeTill_Id = this.entity.ChairmanInChargeTill_Id,
          editchairman[0].ChairmanInChargeTillTenure = (this.entity.ChairmanInChargeTillTenure == null || this.entity.ChairmanInChargeTillTenure == 0) ? 0 : this.entity.ChairmanInChargeTillTenure,
          editchairman[0].Till = (this.entity.ChairmanInChargeTillTenure == null) ? '' : TenureDateChairmanstr,
          editchairman[0].ChairmanInChargeTillDate = chairman_exipirydate;
        editchairman[0].ChairmanInChargeTillDatestr = (this.entity.ChairmanInChargeTillDate == null || new Date(this.entity.ChairmanInChargeTillDate).getFullYear() == 1900) ? '' : this.pipe.transform(this.convertdate(this.entity.ChairmanInChargeTillDate), "dd/MM/yyyy")

        if (this.selectedChairmanEmp === null || this.selectedChairmanEmp === undefined) {
          editchairman[0].Chairman_Emp_Ref_Id = this.selectedChairman != undefined ? this.selectedChairman?.Emp_Ref_Id : "";
          editchairman[0].ChairmanName = this.selectedChairman != undefined ? this.selectedChairman?.ChairmanName : "";
          editchairman[0].EmployeeName = this.selectedChairman != undefined ? this.selectedChairman?.EmployeeName : "";
        }
        else {
          editchairman[0].Chairman_Emp_Ref_Id = this.selectedChairmanEmp != undefined ? this.selectedChairmanEmp?.Emp_Ref_Id : "";
          editchairman[0].ChairmanName = this.selectedChairmanEmp != undefined ? this.selectedChairmanEmp?.EmployeeName : "";
          editchairman[0].EmployeeName = this.selectedChairmanEmp != undefined ? this.selectedChairmanEmp?.EmployeeName : "";
        }
        this.selectedChairman = {};
        this.Chairmanarray = new committeeChairman();
      }

      this.entity.ChairmanInChargeTillTenure = 0;
      this.entity.ChairmanInChargeTillDate = undefined;
    }
    else if (employeeCheck.length == 0) {

      if (this.entity.Chairman_Emp_Ref_Id == null || this.entity.Chairman_Emp_Ref_Id == "" || this.entity.Chairman_Emp_Ref_Id == undefined) {
        this.notification.showWarning('Chairman Name Is Required');
      }
      else if (this.entity.ChairmanJoiningDate == null || this.entity.ChairmanJoiningDate == undefined) {
        this.notification.showWarning('Joining Date Is Required');
      }
      else if ((this.showDateChairman === true) && (this.entity.ChairmanInChargeTillDate == null || this.entity.ChairmanInChargeTillDate == undefined)) {
        this.notification.showWarning("Till Date Is Required");
        return;
      }
      else if ((this.showTenureChairman === true) && (this.entity.ChairmanInChargeTillTenure == null || this.entity.ChairmanInChargeTillTenure == undefined || this.entity.ChairmanInChargeTillTenure == 0)) {
        this.notification.showWarning("Tenure Year Is Required");
        return;
      }
      else {
        joining_date = this.convertdate(this.entity.ChairmanJoiningDate);
        let TenureDateChairmanstr = null;
        if (this.entity.ChairmanInChargeTillTenure > 0) {
          let date = this.entity.ChairmanJoiningDate.setDate(this.entity.ChairmanJoiningDate.getDate() + (365 * this.entity.ChairmanInChargeTillTenure))
          let datePipe: DatePipe = new DatePipe('en-US');
          TenureDateChairmanstr = datePipe.transform(date, 'dd/MM/yyyy');
        }
        this.showDateChairman = false;
        this.showTenureChairman = false;
        data.push({
          Chairman_Emp_Ref_Id: this.selectedChairmanEmp != undefined ? this.selectedChairmanEmp?.Emp_Ref_Id : this.selectedChairman?.Emp_Ref_Id,
          ChairmanName: this.selectedChairmanEmp != undefined ? this.selectedChairmanEmp?.EmployeeName : this.selectedChairman?.ChairmanName,
          EmployeeName: this.selectedChairmanEmp != undefined ? this.selectedChairmanEmp?.EmployeeName : this.selectedChairman?.ChairmanName,
          Committee_Id: this.entity.Committee_Id,
          ChairmanJoiningDate: joining_date,
          ChairmanJoiningDatestr: this.pipe.transform(this.convertdate(joining_date), "dd/MM/yyyy"),
          ChairmanInChargeTill_Id: this.entity.ChairmanInChargeTill_Id,
          ChairmanInChargeTillTenure: (this.entity.ChairmanInChargeTillTenure == null || this.entity.ChairmanInChargeTillTenure == 0) ? '' : this.entity.ChairmanInChargeTillTenure,
          Till: (this.entity.ChairmanInChargeTillTenure == null) ? '' : TenureDateChairmanstr,
          ChairmanInChargeTillDate: (this.entity.ChairmanInChargeTillDate == null || new Date(this.entity.ChairmanInChargeTillDate).getFullYear() == 1900) ? '' : this.convertdate(this.entity.ChairmanInChargeTillDate),
          ChairmanInChargeTillDatestr: (this.entity.ChairmanInChargeTillDate == null || new Date(this.entity.ChairmanInChargeTillDate).getFullYear() == 1900) ? '' : this.pipe.transform(this.convertdate(this.entity.ChairmanInChargeTillDate), "dd/MM/yyyy"),
          Emp_Ref_Id: this.selectedChairmanEmp?.Emp_Ref_Id,
          IsActive: true,
          ChairmanEditBit: 0,
          EntityMetaData: []
        });
        this.Chairmanarray = data;
        this.entity.Chairmanarray = this.Chairmanarray;
        this.entity.ChairmanInChargeTillTenure = 0;
        this.entity.ChairmanInChargeTillDate = undefined;
        if (this.entity.Chairmanarray.length == 0 || this.entity.Committee_Id == "00000000-0000-0000-0000-000000000000") {
          this.chairmandisabled = true;
        }
        else {
          this.chairmandisabled = false;
        }
        this.selectedChairman = {}
        this.Chairmanarray = new committeeChairman();
      }
    }
  };
  // this.Chairmanarray = [];
  //   this.saveDisabled = false;
  //   var joining_date: any;
  //   let chairman_exipirydate:any;
  //   var data = [... this.Chairmanarray];
  //   var employeeCheck = this.entity.Chairmanarray.filter(
  //     Chairmanarray => Chairmanarray.ChairmanEditBit === 1);
  getval_secretary() {
    this.saveDisabled = false;
    this.Secretaryarray = [];
    // this.entity.secretaryarray = [];
    var secretary_exipirydate: any;
    var secretary_exipirytenure: any;
    var joining_date: any;
    var till_date: any;
    var data = [...this.Secretaryarray];

    var employeeCheck = this.entity.secretaryarray.filter(
      secretaryarray => secretaryarray.SecretaryEditBit === 1);

    if (employeeCheck.length == 1) {
      var editSecretary = this.entity.secretaryarray.filter(
        editemployees => editemployees.SecretaryEditBit === 1);

      var editemp = this.entity.secretaryarray.filter(
        editemps => editemps.Emp_Ref_Id === this.Secretaryarray.Emp_Ref_Id && editemps.SecretaryEditBit != 1);
      if (editemp.length > 0) {
        this.notification.showWarning('Secretary Already Exists');
      }
      else {
        joining_date = this.convertdate(this.entity.SecretaryJoiningDate);
        secretary_exipirydate = (this.entity.SecretaryInChargeTillDate == null || new Date(this.entity.SecretaryInChargeTillDate).getFullYear() == 1900) ? '' : this.entity.SecretaryInChargeTillDate;
        secretary_exipirytenure = (this.entity.SecretaryInChargeTillTenure == null || this.entity.SecretaryInChargeTillTenure == 0) ? '' : this.entity.SecretaryInChargeTillTenure;
        let TenureDatesecretarystr = null;
        if (this.entity.SecretaryInChargeTillTenure > 0) {
          let date = this.entity.SecretaryJoiningDate != undefined ? this.entity.SecretaryJoiningDate.setDate(this.entity.SecretaryJoiningDate.getDate() + (365 * this.entity.SecretaryInChargeTillTenure)) : undefined
          let datePipe: DatePipe = new DatePipe('en-US');
          TenureDatesecretarystr = datePipe.transform(date, 'dd/MM/yyyy');
        }
        this.showDate = false;
        this.showTenure = false;
        editSecretary[0].Committee_Id = this.entity.Committee_Id;
        editSecretary[0].SecretaryJoiningDate = joining_date;
        editSecretary[0].SecretaryInChargeTill_Id = this.entity.SecretaryInChargeTill_Id;
        editSecretary[0].SecretaryJoiningDateStr = this.pipe.transform(this.convertdate(joining_date), "dd/MM/yyyy");
        editSecretary[0].SecretaryTenureDate = (this.entity.SecretaryInChargeTillTenure == null) ? '' : TenureDatesecretarystr;
        editSecretary[0].SecretaryInChargeTillTenure = secretary_exipirytenure;
        editSecretary[0].SecretaryInChargeTillDate = secretary_exipirydate;
        editSecretary[0].SecretaryInChargeTillDateStr = (this.entity.SecretaryInChargeTillDate == null || new Date(this.entity.SecretaryInChargeTillDate).getFullYear() == 1900) ? '' : this.pipe.transform(this.convertdate(this.entity.SecretaryInChargeTillDate), "dd/MM/yyyy");

        if (this.selectedSecretaryEmp === null || this.selectedSecretaryEmp === undefined) {
          editSecretary[0].Secretary_Emp_Ref_Id = this.selectedEmployee != undefined ? this.selectedEmployee?.Emp_Ref_Id : "";
          editSecretary[0].SecretaryName = this.selectedEmployee != undefined ? this.selectedEmployee?.SecretaryName : "";
          editSecretary[0].EmployeeName = this.selectedEmployee != undefined ? this.selectedEmployee?.EmployeeName : "";
        }
        else {
          editSecretary[0].Secretary_Emp_Ref_Id = this.selectedSecretaryEmp != undefined ? this.selectedSecretaryEmp?.Emp_Ref_Id : "";
          editSecretary[0].SecretaryName = this.selectedSecretaryEmp != undefined ? this.selectedSecretaryEmp?.EmployeeName : "";
          editSecretary[0].EmployeeName = this.selectedSecretaryEmp != undefined ? this.selectedSecretaryEmp?.EmployeeName : "";
        }
        this.selectedEmployee = {}
        this.Secretaryarray = new committeesecratary();

      }
      this.entity.SecretaryInChargeTillDate = undefined;
      this.entity.SecretaryInChargeTillTenure = 0;
    }
    else if (employeeCheck.length == 0) {

      if (this.entity.Secretary_Emp_Ref_Id == null || this.entity.Secretary_Emp_Ref_Id == "" || this.entity.Secretary_Emp_Ref_Id == undefined) {
        this.notification.showWarning('Secretary Name Is Required');
      }
      else if (this.entity.SecretaryJoiningDate == null || this.entity.SecretaryJoiningDate == undefined) {
        this.notification.showWarning('Joining Date Is Required');
      }
      else if ((this.showDate === true) && (this.entity.SecretaryInChargeTillDate == null || this.entity.SecretaryInChargeTillDate == undefined)) {
        this.notification.showWarning("Till Date Is Required");
        return;
      }
      else if ((this.showTenure === true) && (this.entity.SecretaryInChargeTillTenure == null || this.entity.SecretaryInChargeTillTenure == undefined || this.entity.SecretaryInChargeTillTenure == 0)) {
        this.notification.showWarning("Tenure Year Is Required");
        return;
      }
      else {
        joining_date = this.convertdate(this.entity.SecretaryJoiningDate);
        secretary_exipirydate = (this.entity.SecretaryInChargeTillDate == null || new Date(this.entity.SecretaryInChargeTillDate).getFullYear() == 1900) ? '' : new Date(this.convertdate(this.entity.SecretaryInChargeTillDate));
        // till_date = this.convertdate(this.entity.SecretaryInChargeTillDate);
        let TenureDatesecretarystr = null;
        if (this.entity.SecretaryInChargeTillTenure > 0) {
          let date = this.entity.SecretaryJoiningDate.setDate(this.entity.SecretaryJoiningDate.getDate() + (365 * this.entity.SecretaryInChargeTillTenure))
          let datePipe: DatePipe = new DatePipe('en-US');
          TenureDatesecretarystr = datePipe.transform(date, 'dd/MM/yyyy');
        }
        this.showTenure = false;
        this.showDate = false;
        data.push({
          Secretary_Emp_Ref_Id: this.selectedSecretaryEmp != undefined ? this.selectedSecretaryEmp?.Emp_Ref_Id : this.selectedEmployee?.Emp_Ref_Id,
          SecretaryName: this.selectedSecretaryEmp != undefined ? this.selectedSecretaryEmp?.EmployeeName : this.selectedEmployee?.EmployeeName,
          EmployeeName: this.selectedSecretaryEmp != undefined ? this.selectedSecretaryEmp?.EmployeeName : this.selectedEmployee?.EmployeeName,
          Committee_Id: this.entity.Committee_Id,
          SecretaryJoiningDate: joining_date,
          SecretaryJoiningDateStr: this.pipe.transform(this.convertdate(joining_date), "dd/MM/yyyy"),
          SecretaryInChargeTill_Id: this.entity.SecretaryInChargeTill_Id,
          SecretaryTenureDate: (this.entity.SecretaryInChargeTillTenure == null) ? '' : TenureDatesecretarystr,
          SecretaryInChargeTillTenure: (this.entity.SecretaryInChargeTillTenure == null || this.entity.SecretaryInChargeTillTenure == 0) ? 0 : this.entity.SecretaryInChargeTillTenure,
          SecretaryInChargeTillDate: secretary_exipirydate,
          SecretaryInChargeTillDateStr: (this.entity.SecretaryInChargeTillDate == null || new Date(this.entity.SecretaryInChargeTillDate).getFullYear() == 1900) ? '' : this.pipe.transform(this.convertdate(this.entity.SecretaryInChargeTillDate), "dd/MM/yyyy"),
          Emp_Ref_Id: this.selectedSecretaryEmp?.Emp_Ref_Id,
          IsActive: true,
          SecretaryEditBit: 0,
          EntityMetaData: []
        });
        this.Secretaryarray = data;
        this.entity.secretaryarray = this.Secretaryarray;

        // this.selectedEmployee = {};
        // this.entity.SecretaryJoiningDate = undefined;
        this.entity.SecretaryInChargeTillTenure = 0;
        this.entity.SecretaryInChargeTillDate = undefined;
        if (this.entity.secretaryarray.length == 0 || this.entity.Committee_Id == "00000000-0000-0000-0000-000000000000") {
          this.secretarydisabled = true;
        }
        else {
          this.secretarydisabled = false;
        }
        this.selectedEmployee = {};
        this.Secretaryarray = new committeesecratary();
      }
    }
  };
  getval() {
    this.saveDisabled = false;
    var data = [... this.Memberarray];
    var membership_exipirydate: any;
    var membership_exipirytenure: any;
    var membership_exipirytype: any;
    var membership_exipirytype_id: any;
    var joining_date: any
    var SittingFeeEffective_From: any
    var SittingFeeEffective_To: any
    var MemberInChargeTillDate: any

    var employeeCheck = this.entity.committeememberarray.filter(
      committeememberarray => committeememberarray.MemberEditBit === 1);

    if (employeeCheck.length == 1) {
      var editMember = this.entity.committeememberarray.filter(
        editemployees => editemployees.MemberEditBit === 1);

      var editemp = this.entity.committeememberarray.filter(
        editemps => editemps.Emp_Ref_Id === this.committeememberentity.Emp_Ref_Id && editemps.MemberEditBit != 1);
      if (editemp.length > 0) {
        this.notification.showWarning('Member Already Exists');
      }
      else {
        if (membership_exipirytype_id = 1 && this.committeememberentity.MemberInChargeTillDate != null) {
          membership_exipirydate = (this.committeememberentity.MemberInChargeTillDate == null) ? '' : this.convertdate(this.committeememberentity.MemberInChargeTillDate);
          membership_exipirytenure = 0
          membership_exipirytype = 'Date'
          membership_exipirytype_id = 1
        }
        else if (membership_exipirytype_id = 2 && this.committeememberentity.MemberInChargeTillTenure != null) {
          membership_exipirydate = null;
          membership_exipirytenure = (this.committeememberentity.MemberInChargeTillTenure == null) ? '' : this.committeememberentity.MemberInChargeTillTenure
          membership_exipirytype = 'Tenure'
          membership_exipirytype_id = 2
        }
        SittingFeeEffective_From = (this.committeememberentity.SittingFeeEffectiveFrom == null) ? '' : this.convertdate(this.committeememberentity.SittingFeeEffectiveFrom);
        SittingFeeEffective_To = (this.committeememberentity.SittingFeeEffectiveTo == null) ? '' : this.convertdate(this.committeememberentity.SittingFeeEffectiveTo);
        joining_date = this.convertdate(this.committeememberentity.MemberJoiningDate);

        if (this.committeememberentity.SittingFeeEffectiveFrom != undefined) {
          this.committeememberentity.SittingFeeEffectiveFrom = this.dateService.convertUTCDateToLocalDate(this.committeememberentity.SittingFeeEffectiveFrom);
        }
        if (this.committeememberentity.SittingFeeEffectiveTo != undefined) {
          this.committeememberentity.SittingFeeEffectiveTo = this.dateService.convertUTCDateToLocalDate(this.committeememberentity.SittingFeeEffectiveTo);
        }

        let TenureDateMemstr = null
        if (membership_exipirytenure > 0) {
          let date = this.committeememberentity.MemberJoiningDate.setDate(this.committeememberentity.MemberJoiningDate.getDate() + (365 * membership_exipirytenure));
          let datePipe: DatePipe = new DatePipe('en-US');
          TenureDateMemstr = datePipe.transform(date, 'dd/MM/yyyy');
        }
        this.showDateMember = false;
        this.showTenureMember = false;
        this.checkValue(event);
        editMember[0].Committee_Id = this.entity.Committee_Id;
        editMember[0].JoiningDateStr = this.pipe.transform(this.convertdate(joining_date), "dd/MM/yyyy");
        editMember[0].JoiningDate = joining_date;
        editMember[0].MembershipExpiryType = membership_exipirytype;
        editMember[0].MembershipExpiryDate = membership_exipirydate;
        editMember[0].MembershipExpiryDateStr = (this.committeememberentity.MemberInChargeTillDate == null) ? '' : (this.pipe.transform(this.convertdate(this.committeememberentity.MemberInChargeTillDate), "dd/MM/yyyy"));
        editMember[0].MemberInChargeTillTenureDate = (this.committeememberentity.MembershipExpiryTenure == null) ? '' : TenureDateMemstr,
          editMember[0].MembershipExpiryTenure = membership_exipirytenure;
        editMember[0].MembershipExpiry_Id = membership_exipirytype_id;
        editMember[0].SittingFeeApplicable = this.committeememberentity.SittingFeeApplicable;
        editMember[0].SittingFee = this.committeememberentity.SittingFee;
        editMember[0].SittingFeeEffectiveFrom = SittingFeeEffective_From;
        editMember[0].SittingFeeEffectiveFromStr = this.committeememberentity.SittingFeeApplicable ? (this.committeememberentity.SittingFeeEffectiveTo == null) ? '' : (this.committeememberentity.SittingFeeEffectiveFrom == null) ? '' : this.pipe.transform(this.convertdate(this.committeememberentity.SittingFeeEffectiveFrom), "dd/MM/yyyy") : null;
        editMember[0].SittingFeeEffectiveTo = SittingFeeEffective_To;
        editMember[0].SittingFeeEffectiveToStr = this.committeememberentity.SittingFeeApplicable ? (this.committeememberentity.SittingFeeEffectiveTo == null) ? '' : this.pipe.transform(this.convertdate(this.committeememberentity.SittingFeeEffectiveTo), "dd/MM/yyyy") : null;
        editMember[0].MemberEditBit = 0;
        this.entity.MemberEditBit = 0;

        if (this.selectedMemberEmp === null || this.selectedMemberEmp === undefined) {
          editMember[0].Emp_Ref_Id = this.selectedMember != undefined ? this.selectedMember?.Emp_Ref_Id : "";
          editMember[0].EmployeeName = this.selectedMember != undefined ? this.selectedMember?.EmployeeName : "";
        }
        else {
          editMember[0].Emp_Ref_Id = this.selectedMemberEmp != undefined ? this.selectedMemberEmp?.Emp_Ref_Id : "";
          editMember[0].EmployeeName = this.selectedMemberEmp != undefined ? this.selectedMemberEmp?.EmployeeName : "";
        }

        this.selectedMember = {}
        this.committeememberentity = new committeemember();
      }
    }
    else if (employeeCheck.length == 0) {

      var editemp = this.entity.committeememberarray.filter(
        editemps => editemps.Emp_Ref_Id === this.committeememberentity.Emp_Ref_Id && editemps.MemberEditBit != 1);
      if (editemp.length > 0) {
        this.notification.showWarning('Member Already Exists');
      }
      else {
        if (this.flag == "Date") {
          membership_exipirydate = this.convertdate(this.committeememberentity.MemberInChargeTillDate);
          membership_exipirytenure = 0
          membership_exipirytype = 'Date'
          membership_exipirytype_id = 1
        }
        else {
          membership_exipirydate = null;
          membership_exipirytenure = this.committeememberentity.MemberInChargeTillTenure
          membership_exipirytype = 'Tenure'
          membership_exipirytype_id = 2
        }
        SittingFeeEffective_From = (this.committeememberentity.SittingFeeEffectiveFrom == null) ? '' : this.convertdate(this.committeememberentity.SittingFeeEffectiveFrom);
        SittingFeeEffective_To = (this.committeememberentity.SittingFeeEffectiveTo == null) ? '' : this.convertdate(this.committeememberentity.SittingFeeEffectiveTo);
        joining_date = this.convertdate(this.committeememberentity.MemberJoiningDate);

        if (this.committeememberentity.SittingFeeEffectiveFrom != undefined) {
          this.committeememberentity.SittingFeeEffectiveFrom = this.dateService.convertUTCDateToLocalDate(this.committeememberentity.SittingFeeEffectiveFrom);
        }
        if (this.committeememberentity.SittingFeeEffectiveTo != undefined) {
          this.committeememberentity.SittingFeeEffectiveTo = this.dateService.convertUTCDateToLocalDate(this.committeememberentity.SittingFeeEffectiveTo);
        }
        if (this.committeememberentity.SittingFeeEffectiveFrom != undefined && this.committeememberentity.SittingFeeEffectiveTo != undefined) {
          const actualFromDate = moment(this.committeememberentity.SittingFeeEffectiveFrom).format('YYYY-MM-DD');
          const actualToDate = moment(this.committeememberentity.SittingFeeEffectiveTo).format('YYYY-MM-DD');
          if (actualFromDate > actualToDate) {
            this.notification.showWarning('Sitting Fee Effective To date should be grater than from date');
            return
          }
        }
        if (this.committeememberentity.Emp_Ref_Id == null || this.committeememberentity.Emp_Ref_Id == undefined || this.committeememberentity.Emp_Ref_Id == "") {
          this.notification.showWarning("Member Name Is Required");
          return;
        }
        else if (this.committeememberentity.MemberJoiningDate == null || this.committeememberentity.MemberJoiningDate == undefined) {
          this.notification.showWarning("Joining Date Is Required");
          return;
        }
        else if (this.committeememberentity.SittingFeeApplicable == true && this.committeememberentity.SittingFee == 0) {
          this.notification.showWarning("Sitting Fee Is Required");
          return;
        }
        else if (this.committeememberentity.SittingFeeApplicable == true && (this.committeememberentity.SittingFeeEffectiveFrom == null || this.committeememberentity.SittingFeeEffectiveFrom == undefined)) {
          this.notification.showWarning("Effective From Is Required");
          return;
        }
        else if (this.showDateMember == true && (this.committeememberentity.MemberInChargeTillDate == null || this.committeememberentity.MemberInChargeTillDate == undefined)) {
          this.notification.showWarning("Till Date Is Required");
          return;
        }
        else if (this.showTenureMember == true && (this.committeememberentity.MemberInChargeTillTenure == null || this.committeememberentity.MemberInChargeTillTenure == undefined || this.committeememberentity.MemberInChargeTillTenure == 0)) {
          this.notification.showWarning("Till Year Is Required");
          return;
        }
        else {
          let TenureDateMemstr = null
          if (membership_exipirytenure > 0) {
            let date = this.committeememberentity.MemberJoiningDate.setDate(this.committeememberentity.MemberJoiningDate.getDate() + (365 * membership_exipirytenure));
            let datePipe: DatePipe = new DatePipe('en-US');
            TenureDateMemstr = datePipe.transform(date, 'dd/MM/yyyy');
          }
          this.showDateMember = false;
          this.showTenureMember = false;
          this.checkValue(event);
          data.push({
            Emp_Ref_Id: this.selectedMemberEmp?.Emp_Ref_Id,
            EmployeeName: this.selectedMemberEmp?.EmployeeName,
            Committee_Id: this.entity.Committee_Id,
            JoiningDateStr: this.pipe.transform(this.convertdate(joining_date), "dd/MM/yyyy"),
            JoiningDate: joining_date,
            MembershipExpiryType: membership_exipirytype,
            MembershipExpiryDate: membership_exipirydate,
            MembershipExpiryDateStr: (this.committeememberentity.MemberInChargeTillDate == null) ? '' : (this.pipe.transform(this.convertdate(this.committeememberentity.MemberInChargeTillDate), "dd/MM/yyyy")),
            MemberInChargeTillTenureDate: (this.committeememberentity.MembershipExpiryTenure == null) ? '' : TenureDateMemstr,
            MembershipExpiryTenure: membership_exipirytenure,
            MembershipExpiry_Id: membership_exipirytype_id,
            SittingFeeApplicable: this.committeememberentity.SittingFeeApplicable,
            SittingFee: this.committeememberentity.SittingFee,
            SittingFeeEffectiveFrom: SittingFeeEffective_From,
            SittingFeeEffectiveFromStr: this.committeememberentity.SittingFeeApplicable ? (this.committeememberentity.SittingFeeEffectiveTo == null) ? '' : (this.committeememberentity.SittingFeeEffectiveFrom == null) ? '' : this.pipe.transform(this.convertdate(this.committeememberentity.SittingFeeEffectiveFrom), "dd/MM/yyyy") : null,
            SittingFeeEffectiveTo: SittingFeeEffective_To,
            SittingFeeEffectiveToStr: this.committeememberentity.SittingFeeApplicable ? (this.committeememberentity.SittingFeeEffectiveTo == null) ? '' : this.pipe.transform(this.convertdate(this.committeememberentity.SittingFeeEffectiveTo), "dd/MM/yyyy") : null,
          });
        }

        this.Memberarray = data;
        this.entity.committeememberarray = this.Memberarray;
        if (this.entity.committeememberarray.length == 0 || this.entity.Committee_Id == "00000000-0000-0000-0000-000000000000") {
          this.memberdisabled = true;

        }
        else {
          this.memberdisabled = false;
        }
        this.selectedMember = {}
        this.committeememberentity = new committeemember();
      }
    }
  };

  convertdate(str: any) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  getval_Permenant() {
    this.saveDisabled = false;
    var data = [... this.Inviteesarray];
    var perm_inv_exipirydate: any;
    var perm_inv_exipirytenure: any;
    var perm_inv_exipirytype: any;
    var perm_inv_exipirytype_id: any;
    var joining_date: any;

    var employee = this.Employee_inviteedata.filter(
      Employee_inviteedata => Employee_inviteedata.Emp_Ref_Id === this.committeepermenantInviteesentity.Emp_Ref_Id);

    var employeeCheck = this.entity.permenantInviteesgrid.filter(
      permenantInviteesgrid => permenantInviteesgrid.Emp_Ref_Id === this.committeepermenantInviteesentity.Emp_Ref_Id);

    var employeeCheck = this.entity.permenantInviteesgrid.filter(
      permenantInviteesgrid => permenantInviteesgrid.InviteeEditBit === 1);

    if (employeeCheck.length == 1) {
      var editInvitee = this.entity.permenantInviteesgrid.filter(
        editemployees => editemployees.InviteeEditBit === 1);

      var editemp = this.entity.permenantInviteesgrid.filter(
        editemps => editemps.Emp_Ref_Id === this.committeepermenantInviteesentity.Emp_Ref_Id && editemps.InviteeEditBit != 1);
      if (editemp.length > 0) {
        this.notification.showWarning('Permanent Invitee Already Exists');
      }
      else {
        perm_inv_exipirydate = (this.committeepermenantInviteesentity.PermenantInvInChargeTillDate == null) ? '' : this.convertdate(this.committeepermenantInviteesentity.PermenantInvInChargeTillDate);
        perm_inv_exipirytenure = (this.committeepermenantInviteesentity.PermenantInvInChargeTillTenure == null) ? '' : this.committeepermenantInviteesentity.PermenantInvInChargeTillTenure
        joining_date = this.convertdate(this.committeepermenantInviteesentity.PermenantInvJoiningDate);
        let TenureDatePermstr = null;
        if (perm_inv_exipirytenure > 0) {
          let date = this.committeepermenantInviteesentity.PermenantInvJoiningDate.setDate(this.committeepermenantInviteesentity.PermenantInvJoiningDate.getDate() + (365 * perm_inv_exipirytenure))
          let datePipe: DatePipe = new DatePipe('en-US');
          TenureDatePermstr = datePipe.transform(date, 'dd/MM/yyyy');
        }
        this.showDatePerm = false;
        this.showTenurePerm = false;
        editInvitee[0].Committee_Id = this.entity.Committee_Id,
          editInvitee[0].PermenantInviteeJoiningDate = joining_date,
          editInvitee[0].PermenantInviteeJoiningDateStr = this.pipe.transform(this.convertdate(joining_date), "dd/MM/yyyy");
        editInvitee[0].PermenantInvExpiryType = perm_inv_exipirytype;
        editInvitee[0].TenureDatePerm = (this.committeepermenantInviteesentity.PermenantInvInChargeTillTenure == null) ? '' : TenureDatePermstr;
        editInvitee[0].PermenantInviteeInChargeTillTenure = perm_inv_exipirytenure;
        editInvitee[0].PermenantInviteeInChargeTillDate = perm_inv_exipirydate,
          editInvitee[0].PermenantInviteeInChargeTillDateStr = (this.committeepermenantInviteesentity.PermenantInvInChargeTillDate == null) ? '' : this.pipe.transform(this.convertdate(this.committeepermenantInviteesentity.PermenantInvInChargeTillDate), "dd/MM/yyyy");
        editInvitee[0].InviteeEditBit = 0;
        this.entity.InviteeEditBit = 0;

        if (this.selectedInviteeEmp === null || this.selectedInviteeEmp === undefined) {
          editInvitee[0].Emp_Ref_Id = this.selectedInvitees != undefined ? this.selectedInvitees?.Emp_Ref_Id : "";
          editInvitee[0].EmployeeName = this.selectedInvitees != undefined ? this.selectedInvitees?.EmployeeName : "";
        }
        else {
          editInvitee[0].Emp_Ref_Id = this.selectedInviteeEmp != undefined ? this.selectedInviteeEmp?.Emp_Ref_Id : "";
          editInvitee[0].EmployeeName = this.selectedInviteeEmp != undefined ? this.selectedInviteeEmp?.EmployeeName : "";
        }
        this.selectedInvitees = {};
        this.committeepermenantInviteesentity = new committeepermenantInvitees();
      }

      // var PermenantInvInChargeTillTenure: any;
      // if (this.committeepermenantInviteesentity.Emp_Ref_Id == '00000000-0000-0000-0000-000000000000') {
      //   this.notification.showWarning('Please select Invitee');
    }

    else if (employeeCheck.length == 0) {
      var editemp = this.entity.permenantInviteesgrid.filter(
        editemps => editemps.Emp_Ref_Id === this.committeepermenantInviteesentity.Emp_Ref_Id && editemps.InviteeEditBit != 1);
      if (editemp.length > 0) {
        this.notification.showWarning('Permanent Invitee Already Exists');
      }
      else {
        if (employeeCheck.length == 0) {
          if (this.flag == "Date") {
            perm_inv_exipirydate = this.convertdate(this.committeepermenantInviteesentity.PermenantInvInChargeTillDate);
            perm_inv_exipirytenure = 0
            perm_inv_exipirytype = 'Date'
            perm_inv_exipirytype_id = 1
          }
          else {
            perm_inv_exipirydate = null
            perm_inv_exipirytenure = this.committeepermenantInviteesentity.PermenantInvInChargeTillTenure
            perm_inv_exipirytype = 'Tenure'
            perm_inv_exipirytype_id = 2
          }
          joining_date = this.convertdate(this.committeepermenantInviteesentity.PermenantInvJoiningDate);
          if (this.committeepermenantInviteesentity.Emp_Ref_Id == null || this.committeepermenantInviteesentity.Emp_Ref_Id == undefined || this.committeepermenantInviteesentity.Emp_Ref_Id == "") {
            this.notification.showWarning("Permanent Invitee Name Is Required");
            return;
          }
          else if (this.committeepermenantInviteesentity.PermenantInvJoiningDate == null || this.committeepermenantInviteesentity.PermenantInvJoiningDate == undefined) {
            this.notification.showWarning("Joining Date Is Required");
            return;
          }
          else if ((this.showDatePerm === true) && (this.committeepermenantInviteesentity.PermenantInvInChargeTillDate == null || this.committeepermenantInviteesentity.PermenantInvInChargeTillDate == undefined)) {
            this.notification.showWarning("Till Date Is Required");
            return;
          }
          else if ((this.showTenurePerm === true) && (this.committeepermenantInviteesentity.PermenantInvInChargeTillTenure == null || this.committeepermenantInviteesentity.PermenantInvInChargeTillTenure == undefined || this.committeepermenantInviteesentity.PermenantInvInChargeTillTenure == 0)) {
            this.notification.showWarning("Till Year Is Required");
            return;
          }
          else {
            let TenureDatePermstr = null;
            if (perm_inv_exipirytenure > 0) {
              let date = this.committeepermenantInviteesentity.PermenantInvJoiningDate.setDate(this.committeepermenantInviteesentity.PermenantInvJoiningDate.getDate() + (365 * perm_inv_exipirytenure))
              let datePipe: DatePipe = new DatePipe('en-US');
              TenureDatePermstr = datePipe.transform(date, 'dd/MM/yyyy');
            }
            this.showDatePerm = false;
            this.showTenurePerm = false;
            data.push({
              Emp_Ref_Id: this.selectedInviteeEmp?.Emp_Ref_Id,
              EmployeeName: this.selectedInviteeEmp?.EmployeeName,
              Committee_Id: this.entity.Committee_Id,
              PermenantInviteeJoiningDate: joining_date,
              PermenantInviteeJoiningDateStr: this.pipe.transform(this.convertdate(joining_date), "dd/MM/yyyy"),
              PermenantInvExpiryType: perm_inv_exipirytype,
              // PermenantInviteeInChargeTillDate: perm_inv_exipirydate,
              // PermenantInvExpiryTenure: perm_inv_exipirytenure,
              // PermenantInvExpiry_Id: perm_inv_exipirytenure,
              TenureDatePerm: (this.committeepermenantInviteesentity.PermenantInvInChargeTillTenure == null) ? '' : TenureDatePermstr,
              PermenantInviteeInChargeTillTenure: perm_inv_exipirytenure,
              PermenantInviteeInChargeTillDate: (this.committeepermenantInviteesentity.PermenantInvInChargeTillDate == null) ? '' : this.convertdate(this.committeepermenantInviteesentity.PermenantInvInChargeTillDate),
              PermenantInviteeInChargeTillDateStr: (this.committeepermenantInviteesentity.PermenantInvInChargeTillDate == null) ? '' : this.pipe.transform(this.convertdate(this.committeepermenantInviteesentity.PermenantInvInChargeTillDate), "dd/MM/yyyy"),
            });
          }
          this.Inviteesarray = data;
          this.entity.permenantInviteesgrid = this.Inviteesarray;
          // this.selectedInvitee = null;
        }
        else {
          this.permanentdisabled = false;
          // this.notification.showSuccess('Permenant Invitee Already Exists');
        }
        this.selectedInvitees = {};
        this.committeepermenantInviteesentity = new committeepermenantInvitees();
      }
    }
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._committeeService.deleteCommittee(this.selectedcommittee.Committee_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearCommittee();
            this.getAllCommittee();
          },
          )
        }
      }
      else if (message?.eventName === 'Delete Secretary') {
        if (message?.param.action === 'FA') {
          this.RemoveElementFromObjectSecretaryArray(this.selectedEmployee.Secretary_Emp_Ref_Id);
          this.entity.secretaryarray = [];
          this.entity.Secretary_Emp_Ref_Id = this.Secretaryarray[0].Secretary_Emp_Ref_Id;
          this.entity.Secretary_Emp_Ref_Id = "";
        }
      }
      else if (message?.eventName === 'Delete Chairman') {
        if (message?.param.action === 'FA') {
          this.RemoveElementFromObjectChairmanArray(this.selectedChairman.Chairman_Emp_Ref_Id);
          this.entity.Chairmanarray = [];
          this.entity.Chairman_Emp_Ref_Id = this.Chairmanarray[0].Chairman_Emp_Ref_Id;
          this.entity.Chairman_Emp_Ref_Id = "";
        }
      }
      else if (message?.eventName === 'Delete Member') {
        if (message?.param.action === 'FA') {
          this.RemoveElementFromObjectMemberArray(this.MemberId);
          this.entity.committeememberarray = [];
          this.entity.committeememberarray = this.Memberarray;
          this.MemberId = "";
        }
      }
      else if (message?.eventName === 'Delete Permanent Invitee') {
        if (message?.param.action === 'FA') {
          this.RemoveElementFromObjectArray(this.InviteeId);
          this.entity.permenantInviteesgrid = [];
          this.entity.permenantInviteesgrid = this.Inviteesarray;
          this.InviteeId = "";

        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerCommittee = new PageHeader();
    headerCommittee.PageCaption = " Meeting Type";
    headerCommittee.IconClass = "bi bi-shield-shaded";
    return headerCommittee;
  }

  deleteCommitte(event: any) {
    if (event.seletedRows[0]) {
      this.selectedcommittee.Committee_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: " Meeting Type",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  editPermenantInvitees(event: any) {
    this.permanentdisabled = false;
    this.showDatePerm = false;
    this.showTenurePerm = false;

    for (let i = 0; i < this.entity.permenantInviteesgrid.length; i++) {
      this.entity.permenantInviteesgrid[i].InviteeEditBit = 0;
    }
    if (event.seletedRows[0]) {
      var employee = this.entity.permenantInviteesgrid.filter(
        employees => employees.Emp_Ref_Id === event.seletedRows[0]);
      employee[0].InviteeEditBit = 1;
      this.selectedInvitees = { Emp_Ref_Id: employee[0].Emp_Ref_Id, EmployeeName: employee[0].EmployeeName };
      this.committeepermenantInviteesentity.PermenantInvJoiningDate = new Date(employee[0].PermenantInviteeJoiningDate)
      this.committeepermenantInviteesentity.InviteeEditBit = 1;
      if (employee[0].PermenantInviteeInChargeTillTenure != 0) {
        this.showDatePerm = false;
        this.showTenurePerm = true;
        this.committeepermenantInviteesentity.PermenantInvInChargeTillTenure = employee[0].PermenantInviteeInChargeTillTenure;
      }
      else if (employee[0].PermenantInviteeInChargeTillDate != null &&
        new Date(employee[0].PermenantInviteeInChargeTillDate).getFullYear() != 1900) {
        this.showDatePerm = true;
        this.showTenurePerm = false;
        this.committeepermenantInviteesentity.PermenantInvInChargeTillDate = new Date(employee[0].PermenantInviteeInChargeTillDate);
      }
      else {
        this.showDatePerm = false;
        this.showTenurePerm = false;
      }

      // if (employee[0].PermenantInvInChargeTill_Id == 2 && employee[0].PermenantInvInChargeTillTenure != 0) {
      //   this.showTenurePerm = true;
      //   this.showDate = false;
      //   this.entity.PermenantInviteeInChargeTillTenure = employee[0].PermenantInvInChargeTillTenure;
      // }
      // else if (employee[0].PermenantInvInChargeTill_Id == 1) {
      //   this.showDatePerm = true;
      //   this.showTenurePerm = false;
      //   if (employee[0].PermenantInvInChargeTillDate != null && employee[0].PermenantInvInChargeTillDate != undefined) {
      //     this.entity.PermenantInviteeInChargeTillDate = new Date(employee[0].PermenantInvInChargeTillDate);
      //   }
      // }

      this.getAllEmployee('');
      this.getAllMeeting_type('');
      this.entity.permenantInviteesgrid = [];
      this.entity.permenantInviteesgrid = this.Inviteesarray;
    }
  }
  deletepermenantInvitees(event: any) {
    if (event.seletedRows[0]) {
      this.InviteeId = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Commitee Permanent Invitee",
          returnKey: "Delete Permanent Invitee",
          Key: event.seletedRows[0]
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  editchairmandetails(event: any) {
    this.chairmandisabled = false;
    this.showDateChairman = false;
    this.showTenureChairman = false;

    for (let i = 0; i < this.entity.Chairmanarray.length; i++) {
      this.entity.Chairmanarray[i].ChairmanEditBit = 0;
    }
    if (event.seletedRows[0]) {
      var employee = this.entity.Chairmanarray.filter(
        employees => employees.Chairman_Emp_Ref_Id === event.seletedRows[0]);

      employee[0].ChairmanEditBit = 1;
      this.selectedChairman = { Emp_Ref_Id: employee[0].Chairman_Emp_Ref_Id, EmployeeName: employee[0].ChairmanName, ChairmanName: employee[0].ChairmanName };
      this.entity.Chairman_Emp_Ref_Id = this.selectedChairman.Emp_Ref_Id;

      if (employee[0].ChairmanJoiningDate != undefined) {
        this.entity.ChairmanJoiningDate = new Date(employee[0].ChairmanJoiningDate);
      }
      this.entity.ChairmanInChargeTill_Id = employee[0].ChairmanInChargeTill_Id;
      this.entity.ChairmanEditBit = 1;

      if (employee[0].ChairmanInChargeTill_Id == 2 || employee[0].ChairmanInChargeTillTenure != 0) {
        this.showTenureChairman = true;
        this.showDateChairman = false;
        this.entity.ChairmanInChargeTillTenure = employee[0].ChairmanInChargeTillTenure;
      }
      else if (employee[0].ChairmanInChargeTill_Id == 1) {
        this.showDateChairman = true;
        this.showTenureChairman = false;
        if (employee[0].ChairmanInChargeTillDate != null && employee[0].ChairmanInChargeTillDate != undefined) {
          this.entity.ChairmanInChargeTillDate = new Date(employee[0].ChairmanInChargeTillDate);
        }
      }
      else {
        this.showTenureChairman = false;
        this.showDateChairman = false;
      }
      this.getAllEmployee_Invitees('');
    }
  }
  editSecretarydetails(event: any) {
    this.secretarydisabled = false;
    this.showDate = false;
    this.showTenure = false;

    for (let i = 0; i < this.entity.secretaryarray.length; i++) {
      this.entity.secretaryarray[i].SecretaryEditBit = 0;
    }
    if (event.seletedRows[0]) {
      var employee = this.entity.secretaryarray.filter(
        employees => employees.Secretary_Emp_Ref_Id === event.seletedRows[0]);
      employee[0].SecretaryEditBit = 1;
      this.selectedEmployee = { Emp_Ref_Id: employee[0].Secretary_Emp_Ref_Id, EmployeeName: employee[0].SecretaryName, SecretaryName: employee[0].SecretaryName };
      if (employee[0].SecretaryJoiningDate != undefined) {
        this.entity.SecretaryJoiningDate = new Date(employee[0].SecretaryJoiningDate);
      }
      this.entity.SecretaryInChargeTill_Id = employee[0].SecretaryInChargeTill_Id;
      this.entity.SecretaryEditBit = 1;

      if (employee[0].SecretaryInChargeTill_Id == 2 && employee[0].SecretaryInChargeTillTenure != 0) {
        this.showTenure = true;
        this.showDate = false;
        this.entity.SecretaryInChargeTillTenure = employee[0].SecretaryInChargeTillTenure;
      }
      else if (employee[0].SecretaryInChargeTill_Id == 1) {
        this.showDate = true;
        this.showTenure = false;
        if (employee[0].SecretaryInChargeTillDate != null && employee[0].SecretaryInChargeTillDate != undefined) {
          this.entity.SecretaryInChargeTillDate = new Date(employee[0].SecretaryInChargeTillDate);
        }
      }
      else {
        this.showDate = false;
        this.showTenure = false;
      }
      this.getAllEmployee_Chairman('');
    }
  }

  editMember(event: any) {
    this.memberdisabled = false;
    this.showDateMember = false;
    this.showTenureMember = false;

    for (let i = 0; i < this.entity.committeememberarray.length; i++) {
      this.entity.committeememberarray[i].MemberEditBit = 0;
    }
    if (event.seletedRows[0]) {
      var employee = this.entity.committeememberarray.filter(
        employees => employees.Emp_Ref_Id === event.seletedRows[0]);
      employee[0].MemberEditBit = 1;
      this.selectedMember = { Emp_Ref_Id: employee[0].Emp_Ref_Id, EmployeeName: employee[0].EmployeeName };
      this.committeememberentity.MemberJoiningDate = new Date(employee[0].JoiningDate);
      this.committeememberentity.SittingFeeApplicable = employee[0].SittingFeeApplicable;
      this.committeememberentity.MembershipExpiry_Id = employee[0].MembershipExpiry_Id;
      this.committeememberentity.MemberEditBit = 1;
      if (this.committeememberentity.SittingFeeApplicable == false) {
        this.entity.SittingFee = 0;
        this.showsittingfee = false;
        this.showDateMember = false;
        this.showTenureMember = false;

      }
      else if (this.committeememberentity.SittingFeeApplicable == true) {
        this.committeememberentity.SittingFee = employee[0].SittingFee;
        this.showsittingfee = true;
        this.showDateMember = false;
        this.showTenureMember = false;
        if (employee[0].SittingFeeEffectiveFrom != undefined) {
          this.committeememberentity.SittingFeeEffectiveFrom = new Date(employee[0].SittingFeeEffectiveFrom)
        }
        if (employee[0].SittingFeeEffectiveTo != undefined) {
          this.committeememberentity.SittingFeeEffectiveTo = new Date(employee[0].SittingFeeEffectiveTo)
        }


      }
      if (this.committeememberentity.MembershipExpiry_Id == 2 && employee[0].MembershipExpiryTenure != 0) {
        // let MemberInChargeTillTenureDate = null
        // let date = this.committeememberentity.MemberJoiningDate.setDate(this.committeememberentity.MemberJoiningDate.getDate() + (365 * (employee[0].MembershipExpiryTenure)));
        // let datePipe: DatePipe = new DatePipe('en-US');
        // MemberInChargeTillTenureDate = datePipe.transform(date, 'dd/MM/yyyy');

        this.showTenureMember = true;
        this.showDateMember = false;
        this.committeememberentity.MemberInChargeTillTenure = employee[0].MembershipExpiryTenure
        // this.committeememberentity.MemberInChargeTillTenureDate = MemberInChargeTillTenureDate;
      }
      else if (this.committeememberentity.MembershipExpiry_Id == 1) {
        this.showDateMember = true;
        this.showTenureMember = false;
        this.committeememberentity.MemberInChargeTillDate = new Date(employee[0].MembershipExpiryDate);
      }
      this.getAllEmployee('');
      // this.RemoveElementFromObjectMemberArray(event.seletedRows[0]);
      this.getAllMeeting_type('');
      this.entity.committeememberarray = [];
      this.entity.committeememberarray = this.Memberarray;
    }
  }
  deletechairman(event: any) {
    if (this.entity.Chairmanarray[0].Chairman_Emp_Ref_Id) {
      this.entity.Chairman_Emp_Ref_Id = this.entity.Chairmanarray[0].Chairman_Emp_Ref_Id;
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Commitee Chairman",
          returnKey: "Delete Chairman",
          // Key: this.Chairmanarray[0].Chairman_Emp_Ref_Id
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  deleteSecretary(event: any) {
    if (this.entity.secretaryarray[0].Secretary_Emp_Ref_Id) {
      this.entity.Secretary_Emp_Ref_Id = this.entity.secretaryarray[0].Secretary_Emp_Ref_Id;
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Commitee Secretary",
          returnKey: "Delete Secretary",
          // Key: event.seletedRows[0]
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  deleteMember(event: any) {
    if (event.seletedRows[0]) {
      this.MemberId = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Commitee Members",
          returnKey: "Delete Member",
          Key: event.seletedRows[0]
        }
      };
      this.messageService.sendCommonMessage(message);

      // this.RemoveElementFromObjectMemberArray(event.seletedRows[0]);
      // this.entity.committeememberarray = [];
      // this.entity.committeememberarray = this.Memberarray;
    }
  }
  RemoveElementFromObjectMemberArray(key: string) {
    var dataMembergrid = [... this.entity.committeememberarray];

    dataMembergrid.forEach((value, index) => {
      if (value.Emp_Ref_Id == key) dataMembergrid.splice(index, 1);
    });
    this.Memberarray = [];
    this.Memberarray = dataMembergrid;
  };
  RemoveElementFromObjectChairmanArray(key: string) {
    var dataChairmangrid = [... this.entity.Chairmanarray];

    dataChairmangrid.forEach((value, index) => {
      if (value.Chairman_Emp_Ref_Id == key) dataChairmangrid.splice(index, 1);
    });
    this.Chairmanarray = [];
    this.Chairmanarray = dataChairmangrid;
  };
  RemoveElementFromObjectSecretaryArray(key: string) {
    var dataSecretarygrid = [... this.entity.secretaryarray];

    dataSecretarygrid.forEach((value, index) => {
      if (value.Secretary_Emp_Ref_Id == key) dataSecretarygrid.splice(index, 1);
    });
    this.Secretaryarray = [];
    this.Secretaryarray = dataSecretarygrid;
  };
  RemoveElementFromObjectArray(key: string) {
    var datapermenantInviteesgrid = [... this.entity.permenantInviteesgrid];

    datapermenantInviteesgrid.forEach((value, index) => {
      if (value.Emp_Ref_Id == key) datapermenantInviteesgrid.splice(index, 1);
    });
    this.Inviteesarray = [];
    this.Inviteesarray = datapermenantInviteesgrid;
  };
  addCommittee(event: any) {
    // this.Secretaryarray=[];
    this._selectedDepartment = {};
    this._selectedcommittee = {};
    this.selectedQuorum = {};
    this.selectedmeeting = {};
    this.selectedEmployee = {};
    this.listView = false;
    // this.clearCommittee();
    this.clearSecretary();
    this.clearCommittee();
    this.clearMember();
    this.clearPermenant();
    this.getAllDepartments('');
    this.getAllMeeting_type('');
    this.getAllEmployee('');
    this.getAllEmployee_member('');
    this.getAllEmployee_Chairman('');
    this.getAllEmployee_reviewer('');
    this.getAllInvitees('');
    this.getAllact('');
    this.getAllOrganizer('');
    this.getAllMultiDepartment('');
    this.getAllQuorumOptions('');
    this.getAllEmployee_Invitees('');
    this.formCaption = "New  Meeting Type";
    this.aciveTab = 0;
    setTimeout(() => {
      this.goToNextTab();
    }, 100);
  }

  editCommittee(event: any): void {
    if (event.seletedRows[0]) {
      this.saveDisabled = false;
      this.memberdisabled = false;
      this.chairmandisabled = false;
      this.permanentdisabled = false;
      this.secretarydisabled = false;
      this.isDownloadButtonVisible=true;
      this.entity.SecretaryJoiningDate = undefined;
      this._committeeService.viewcommittee(event.seletedRows[0]).subscribe((committee: any) => {
        this.aciveTab = 0;
        let editEnity = committee;
        if (editEnity) {
          editEnity.Response_Committee_Id = editEnity.Committee_Id;
          this.editingEntity = editEnity;
          this.editingEntity.DateOfFormation = new Date(editEnity.DateOfFormation);
          if (editEnity.SecretaryJoiningDate != "1900-01-01T00:00:00") {
            this.editingEntity.SecretaryJoiningDate = new Date(editEnity.SecretaryJoiningDate)
          }
          else {
            this.editingEntity.SecretaryJoiningDate = undefined;
          }
          if (editEnity.ChairmanJoiningDate != "1900-01-01T00:00:00") {
            this.editingEntity.ChairmanJoiningDate = new Date(editEnity.ChairmanJoiningDate)
          }
          else {
            this.editingEntity.ChairmanJoiningDate = undefined;
          }
          this.entity = { ...this.editingEntity };
          this._selectedDepartment = { Department_Id: editEnity.Department_Id, DepartmentName: editEnity.DepartmentName };
          this.selectedEmployee = { Emp_Ref_Id: editEnity.Secretary_Emp_Ref_Id, EmployeeName: editEnity.SecretaryName, SecretaryName: editEnity.SecretaryName },
            this.selectedChairman = { Emp_Ref_Id: editEnity.Chairman_Emp_Ref_Id, EmployeeName: editEnity.ChairmanName, ChairmanName: editEnity.ChairmanName },
            this.selectedMember = { Member_Id: editEnity.Member_Emp_Ref_Id, Membername: editEnity.Membername };
          this.selectedQuorum = { DisplayValue: editEnity.QuorumOptions_Id, DisplayText: editEnity.QuorumOptionValue };
          this.selectedmeeting = { MeetingType_Id: editEnity.MeetingType_Id, MeetingTypeName: editEnity.MeetingTypeName };
          this.entity.reviewrDepartmentName = this.editingEntity.DepartmentName;
          this.entity.secretaryarray = [];

          let joining_date;
          var secretary_exipirydate: any;
          if (this.entity.SecretaryJoiningDate != undefined) {
            joining_date = this.entity.SecretaryJoiningDate != undefined ? this.convertdate(this.entity.SecretaryJoiningDate) : "";
          }
          else {
            joining_date = "";
          }
          secretary_exipirydate = this.editingEntity.SecretaryInChargeTillDate;

          let TenureDatesecretarystr = null;
          if (this.entity.SecretaryInChargeTillTenure > 0) {
            let date = this.entity.SecretaryJoiningDate != undefined ? this.entity.SecretaryJoiningDate.setDate(this.entity.SecretaryJoiningDate.getDate() + (365 * this.entity.SecretaryInChargeTillTenure)) : undefined;
            let datePipe: DatePipe = new DatePipe('en-US');
            TenureDatesecretarystr = datePipe.transform(date, 'dd/MM/yyyy');
          }
          this.entity.SecretaryJoiningDate = new Date(joining_date);
          if (this.entity.SecretaryName != "" && this.entity.SecretaryName != null && this.entity.SecretaryName != undefined) {
            this.entity.secretaryarray.push({
              SecretaryName: this.entity.SecretaryName,
              EmployeeName: this.entity.SecretaryName,
              Committee_Id: this.editingEntity.Committee_Id,
              IsActive: true,
              Secretary_Emp_Ref_Id: this.editingEntity.Secretary_Emp_Ref_Id,
              SecretaryJoiningDate: new Date(joining_date),
              SecretaryInChargeTill_Id: this.editingEntity.SecretaryInChargeTill_Id,
              SecretaryInChargeTillDate: secretary_exipirydate,
              SecretaryInChargeTillTenure: this.editingEntity.SecretaryInChargeTillTenure,
              SecretaryEditBit: 0,
              SecretaryJoiningDateStr: this.pipe.transform(this.convertdate(joining_date), "dd/MM/yyyy"),
              Emp_Ref_Id: this.editingEntity.Secretary_Emp_Ref_Id,
              SecretaryTenureDate: (this.entity.SecretaryInChargeTillTenure == null) ? '' : TenureDatesecretarystr,
              SecretaryInChargeTillDateStr: (this.entity.SecretaryInChargeTillDate == null || new Date(this.entity.SecretaryInChargeTillDate).getFullYear() == 1900) ? '' : this.pipe.transform(this.convertdate(this.entity.SecretaryInChargeTillDate), "dd/MM/yyyy"),
              EntityMetaData: []
            });
          }
          this.entity.SecretaryInChargeTill_Id = this.editingEntity.SecretaryInChargeTill_Id;
          this.entity.SecretaryEditBit = 1;

          if (this.editingEntity.SecretaryInChargeTill_Id == 2 && this.editingEntity.SecretaryInChargeTillTenure != 0) {
            this.showTenure = true;
            this.showDate = false;
            this.entity.SecretaryInChargeTillTenure = this.editingEntity.SecretaryInChargeTillTenure;
          }
          else if (this.editingEntity.SecretaryInChargeTill_Id == 1) {
            this.showDate = true;
            this.showTenure = false;
            if (this.editingEntity.SecretaryInChargeTillDate != null && this.editingEntity.SecretaryInChargeTillDate != undefined) {
              this.entity.SecretaryInChargeTillDate = new Date(this.editingEntity.SecretaryInChargeTillDate);
            }
          }
          this.entity.Chairmanarray = [];
          if (this.entity.ChairmanJoiningDate != undefined) {
            joining_date = this.entity.ChairmanJoiningDate != undefined ? this.convertdate(this.entity.ChairmanJoiningDate) : "";
          }
          else {
            joining_date = "";
          }
          joining_date = this.convertdate(this.entity.ChairmanJoiningDate);
          let TenureDateChairmanstr = null;
          if (this.entity.ChairmanInChargeTillTenure > 0) {
            let date = this.entity.ChairmanJoiningDate != undefined ? this.entity.ChairmanJoiningDate.setDate(this.entity.ChairmanJoiningDate.getDate() + (365 * this.entity.ChairmanInChargeTillTenure)) : undefined;
            let datePipe: DatePipe = new DatePipe('en-US');
            TenureDateChairmanstr = datePipe.transform(date, 'dd/MM/yyyy');
          }
          this.entity.ChairmanJoiningDate = new Date(joining_date);
          if (this.entity.ChairmanName != "" && this.entity.ChairmanName != null && this.entity.ChairmanName != undefined) {
            this.entity.Chairmanarray.push({
              Chairman_Emp_Ref_Id: this.editingEntity.Chairman_Emp_Ref_Id,
              ChairmanName: this.entity.ChairmanName,
              Committee_Id: this.editingEntity.Committee_Id,
              IsActive: true,
              ChairmanJoiningDate: new Date(joining_date),
              ChairmanJoiningDatestr: this.pipe.transform(this.convertdate(joining_date), "dd/MM/yyyy"),
              ChairmanInChargeTill_Id: this.editingEntity.ChairmanInChargeTill_Id,
              ChairmanInChargeTillDate: this.editingEntity.ChairmanInChargeTillDate,
              ChairmanInChargeTillTenure: this.editingEntity.ChairmanInChargeTillTenure,
              ChairmanEditBit: 0,
              Till: (this.entity.ChairmanInChargeTillTenure == null) ? '' : TenureDateChairmanstr,
              Emp_Ref_Id: this.editingEntity.Chairman_Emp_Ref_Id,
              EmployeeName: this.entity.ChairmanName,
              UserName: this.entity.ChairmanName,
              ChairmanInChargeTillDatestr: (this.entity.ChairmanInChargeTillDate == null || new Date(this.entity.ChairmanInChargeTillDate).getFullYear() == 1900) ? '' : this.pipe.transform(this.convertdate(this.entity.ChairmanInChargeTillDate), "dd/MM/yyyy"),
              EntityMetaData: []
            });
          }
          this.entity.ChairmanInChargeTill_Id = this.editingEntity.ChairmanInChargeTill_Id;
          this.entity.ChairmanEditBit = 1;

          if (this.editingEntity.ChairmanInChargeTill_Id == 2 || this.editingEntity.ChairmanInChargeTillTenure != 0) {
            this.showTenureChairman = true;
            this.showDateChairman = false;
            this.entity.ChairmanInChargeTillTenure = this.editingEntity.ChairmanInChargeTillTenure;
          }
          else if (this.editingEntity.ChairmanInChargeTill_Id == 1) {
            this.showDateChairman = true;
            this.showTenureChairman = false;
            if (this.entity.ChairmanInChargeTillDate != null) {
              this.entity.ChairmanInChargeTillDate = new Date(this.entity.ChairmanInChargeTillDate);
            }
          }
          this.listView = false;
          this.formCaption = "Edit Meeting Type ";
          this.getAllDepartments('');
          this.getAllEmployee('');
          this.getAllEmployee_member('');
          this.getAllEmployee_Chairman(this.editingEntity.Committee_Id);
          this.getAllEmployee_reviewer('');
          this.getAllMeeting_type('');
          this.getAllQuorumOptions('');
          this.getAllInvitees('');
          this.getAllact('');
          this.getAllOrganizer('');
          this.getAllMultiDepartment('');
          this.getAllEmployee_Invitees('');
          setTimeout(() => {
            this.goToNextTab();
          }, 100);
          this.entity.Act = this.editingEntity.Act;
          this.entity.Organizer = this.editingEntity.Organizer;
          this.entity.multidepartment = this.editingEntity.multidepartment;
          for (var i = 0; i < this.editingEntity.committeememberarray.length; i++) {
            if (this.editingEntity.committeememberarray[i].MembershipExpiryTenure > 0) {
              let joiningDate = new Date(this.editingEntity.committeememberarray[i].JoiningDate);
              let date = joiningDate != null ? (joiningDate.setDate(joiningDate.getDate() + (365 * this.editingEntity.committeememberarray[i].MembershipExpiryTenure))) : null;
              let datePipe: DatePipe = new DatePipe('en-US');
              this.editingEntity.committeememberarray[i].MemberInChargeTillTenureDate = datePipe.transform(date, 'dd/MM/yyyy');
            }
          }
          for (var j = 0; j < this.editingEntity.permenantInviteesgrid.length; j++) {
            if (this.editingEntity.permenantInviteesgrid[j].PermenantInviteeInChargeTillTenure > 0) {
              let joiningDateinv = new Date(this.editingEntity.permenantInviteesgrid[j].PermenantInviteeJoiningDate);
              let date = joiningDateinv != null ? (joiningDateinv.setDate(joiningDateinv.getDate() + (365 * this.editingEntity.permenantInviteesgrid[j].PermenantInviteeInChargeTillTenure))) : null;
              let datePipe: DatePipe = new DatePipe('en-US');
              this.editingEntity.permenantInviteesgrid[j].TenureDatePerm = datePipe.transform(date, 'dd/MM/yyyy');
            }
          }
          this.entity.committeememberarray = this.editingEntity.committeememberarray;
          this.Memberarray = this.editingEntity.committeememberarray;
          this.entity.permenantInviteesgrid = this.editingEntity.permenantInviteesgrid;
          this.Inviteesarray = this.editingEntity.permenantInviteesgrid;
          this.Secretaryarray = this.editingEntity.secretaryarray;
          this.Chairmanarray = this.editingEntity.Chairmanarray;
          this.getAllEmployee_Chairman(event.seletedRows[0])
          this.entity.EntityMetaData = [
            { FieldName: 'CommitteeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Committee is required' },
            { FieldName: 'Department_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department Name is required' },
            { FieldName: 'ShortName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Code is required' },
            { FieldName: 'MeetingType_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting Group is required' },
            { FieldName: 'DateOfFormation', FieldType: FieldType.Date, IsMandatory: true, ValidationMessage: 'Date Of Formation is required' },
          ];
        }
      });
    }
  }
  checkValue(event: any) {
    if (event == true) {
      this.showsittingfee = true;
    }
    else {
      this.showsittingfee = false;
    }
  };
  saveSecretaryDetails(event: any, Saveflag: boolean) {
    if (this.entity.Response_Committee_Id) {
      this.entity.Committee_Id = this.entity.Response_Committee_Id;
      this.selectedmeeting = { MeetingType_Id: this.entity.MeetingType_Id, MeetingTypeName: this.entity.MeetingTypeName };
      this.entity.Secretary_Emp_Ref_Id = this.entity.secretaryarray[0].Secretary_Emp_Ref_Id != undefined ? this.entity.secretaryarray[0].Secretary_Emp_Ref_Id : '';
      this.entity.SecretaryName = this.entity.secretaryarray[0].SecretaryName != null ? this.entity.secretaryarray[0].SecretaryName : ' ';
      this.entity.SecretaryJoiningDate = this.entity.secretaryarray[0].SecretaryJoiningDate
      this.entity.SecretaryInChargeTill_Id = this.entity.secretaryarray[0].SecretaryInChargeTill_Id;
      if (this.entity.secretaryarray[0].SecretaryInChargeTill_Id === 0) {
        this.entity.SecretaryInChargeTillDate = undefined;
        this.entity.SecretaryInChargeTillTenure = 0;
      }
      else if (this.entity.secretaryarray[0].SecretaryInChargeTill_Id === 1) {
        this.entity.SecretaryInChargeTillDate = this.entity.secretaryarray[0].SecretaryInChargeTillDate;
        this.entity.SecretaryInChargeTillTenure = 0;

      }
      else {
        this.entity.SecretaryInChargeTillDate = undefined;
        this.entity.SecretaryInChargeTillTenure = this.entity.secretaryarray[0].SecretaryInChargeTillTenure;
      }
      // if (this.entity.Chairman_Emp_Ref_Id != null && this.entity.Chairman_Emp_Ref_Id != undefined) {
      //   this.entity.Chairman_Emp_Ref_Id = this.entity.Chairmanarray[0].Chairman_Emp_Ref_Id;
      //   this.entity.ChairmanJoiningDate = this.entity.Chairmanarray[0].ChairmanJoiningDate;
      // }
      this._committeeService.savecommittee(this.entity).subscribe(() => {
        this.notification.showSuccess('Saved Successfully');
        this.secretarydisabled = false;
        this.entity.SecretaryInChargeTillTenure = 0;
        this.entity.SecretaryJoiningDate = undefined;
      })
    }
    // else {
    //   this._committeeService.savecommittee(this.entity).subscribe(() => {
    //     // if (this.entity.Committee_Id == "00000000-0000-0000-0000-000000000000") {
    //     this.notification.showSuccess('Updated Successfully');
    //   })
    // }
    this.secretarydisabled = false;
  }
  saveChairmanDetails(event: any, Saveflag: boolean) {
    if (this.entity.Response_Committee_Id) {
      this.entity.Committee_Id = this.entity.Response_Committee_Id;
      this.entity.Chairman_Emp_Ref_Id = this.entity.Chairmanarray[0].Chairman_Emp_Ref_Id != undefined ? this.entity.Chairmanarray[0].Chairman_Emp_Ref_Id : '';
      this.entity.ChairmanName = this.entity.Chairmanarray[0].ChairmanName != null ? this.entity.Chairmanarray[0].ChairmanName : ' ';
      this.entity.ChairmanJoiningDate = this.entity.Chairmanarray[0].ChairmanJoiningDate
      this.entity.ChairmanInChargeTill_Id = this.entity.Chairmanarray[0].ChairmanInChargeTill_Id;
      if (this.entity.Chairmanarray[0].ChairmanInChargeTill_Id === 0) {
        this.entity.ChairmanInChargeTillDate = undefined;
        this.entity.ChairmanInChargeTillTenure = 0;
      }
      else if (this.entity.Chairmanarray[0].ChairmanInChargeTill_Id === 1) {
        this.entity.ChairmanInChargeTillDate = this.entity.Chairmanarray[0].ChairmanInChargeTillDate;
        this.entity.ChairmanInChargeTillTenure = 0;

      }
      else {
        this.entity.ChairmanInChargeTillDate = undefined;
        this.entity.ChairmanInChargeTillTenure = this.entity.Chairmanarray[0].ChairmanInChargeTillTenure;

      }
      if (this.entity.Secretary_Emp_Ref_Id != null && this.entity.Secretary_Emp_Ref_Id != undefined) {
        this.entity.Secretary_Emp_Ref_Id = this.entity.secretaryarray[0].Secretary_Emp_Ref_Id;
        this.entity.SecretaryJoiningDate = this.entity.secretaryarray[0].SecretaryJoiningDate;
      }
      this._committeeService.savecommittee(this.entity).subscribe(() => {
        this.notification.showSuccess('Saved Successfully');
        this.chairmandisabled = false;
      })
    }
    // this.entity.Act = [];
    // this.entity.Organizer=[];
    // if (this.entity.Chairman_Emp_Ref_Id == null || this.entity.Chairman_Emp_Ref_Id == "" || this.entity.Chairman_Emp_Ref_Id == undefined) {
    //   this.notification.showWarning('Chairman Name Is Required');
    // }
    // else if (this.entity.ChairmanJoiningDate == null || this.entity.ChairmanJoiningDate == undefined) {
    //   this.notification.showWarning('Joining Date Is Required');
    // }
    //   // else {
    //   //   this._committeeService.savecommittee(this.entity).subscribe(() => {
    //   //     this.notification.showSuccess('Saved Successfully');
    //   //     // this.selectedChairman = { Emp_Ref_Id: this.entity.Chairman_Emp_Ref_Id, EmployeeName: this.entity.ChairmanName };
    //   //   })
    //   // }
  }
  save(event: any, Saveflag: boolean): void {

    if (this.entity.Response_Committee_Id) {
      this.entity.Committee_Id = this.entity.Response_Committee_Id
    }
    this.saveDisabled = Saveflag;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._committeeService.checkDuplication(this.entity.ShortName, this.entity.Committee_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Code already exists');
          this.saveDisabled = false;
        }
        // if(this.selectedmeeting==null || this.selectedmeeting=="" ||this.selectedmeeting==undefined){
        //   // if (res.Success == false) {
        //     this.notification.showWarning('Meeting Group is Required');
        //     // this.saveDisabled = false;
        // }
        // if(this.entity.DepartmentName==null || this.entity.DepartmentName=="" ||this.entity.DepartmentName==undefined){
        //   //  if (res.Success == false) {
        //     this.notification.showWarning('Organising Department is Required');
        //     // this.saveDisabled = false;
        // }
        else {
          this.act_list = [];
          if (this.mappingentity.Act != undefined) {
            for (let i = 0; i < this.mappingentity.Act.length; i++) {
              this.act_list.push({ Act_Id: this.mappingentity.Act[i].Act_Id, ActName: this.mappingentity.Act[i].CommitteeAct_Id });
            }
          }

          this.organizer_list = [];
          if (this.mappingentity.Organizer != undefined) {
            for (let i = 0; i < this.mappingentity.Organizer.length; i++) {
              this.organizer_list.push({ Emp_Ref_Id: this.mappingentity.Organizer[i].Emp_Ref_Id, UserName: this.mappingentity.Organizer[i].EmployeeName });
            }
          }
          this.dept_list = [];
          if (this.mappingentity.multidepartment != undefined) {
            for (let i = 0; i < this.mappingentity.multidepartment.length; i++) {
              this.dept_list.push({ Department_Id: this.mappingentity.multidepartment[i].Department_Id, DepartmentName: this.mappingentity.multidepartment[i].DepartmentName });
            }
          }
          if (this.entity.Document != null && this.entity.Document != undefined) {
            if (this.entity.Document.type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && this.entity.Document.type != 'application/pdf') {
              this.notification.showWarning('You have Choosed Incorrect File Format');
              return
            }
            else {
              this.fileUploader.upload(this.entity.Document, '').subscribe((result: any) => {
                if (result.succeeded) {
                  this.entity.Ref_Id = result.documentId;
                  this.entity.docTittle=this.entity.Document.name
                }

                this._committeeService.savecommittee(this.entity).subscribe((commiteeresult: any) => {
                  let saveentity = commiteeresult
                  this.entity.Response_Committee_Id = saveentity[0].Response_Committee_Id
                  if (this.entity.Committee_Id == "00000000-0000-0000-0000-000000000000") {
                    this.notification.showSuccess('Saved Successfully');
                    this.selectedmeeting = { MeetingType_Id: this.entity.MeetingType_Id, MeetingTypeName: this.entity.MeetingTypeName };
                    // this._selectedcommittee={DepartmentName:this.entity.DepartmentName,Department_Id:this.entity.Department_Id};
                    // this.selectedQuorum = { DisplayText: this.entity.QuorumOptions_Id, DisplayValue: this.entity.QuorumOptionValue };
                    this.secretarydisabled = false;
                    this.permanentdisabled = false;
                    this.memberdisabled = false;
                  }

                  else {
                    this.notification.showSuccess('Updated Successfully');
                  }
                  this.entity.Committee_Id = commiteeresult.Committee_Id;
                  this.entity.reviewrDepartmentName = this.entity.DepartmentName;
                })

              })
            }
          }
          else {
            if (this.entity.QuorumOptions_Id == null) {
              this.entity.QuorumOptions_Id = 0;
            }
            this._committeeService.savecommittee(this.entity).subscribe((commiteeresult: any) => {
              this.entity.Ref_Id = '';
              let saveentity = commiteeresult
              this.entity.Response_Committee_Id = saveentity[0].Response_Committee_Id
              this._selectedDepartment = { DepartmentName: this.entity.DepartmentName, Department_Id: this.entity.Department_Id };
              this.selectedQuorum = { DisplayValue: this.entity.QuorumOptions_Id, DisplayText: this.entity.QuorumOptionValue };
              this.selectedmeeting = { MeetingType_Id: this.entity.MeetingType_Id, MeetingTypeName: this.entity.MeetingTypeName };
              if (this.entity.Committee_Id == "00000000-0000-0000-0000-000000000000") {
                this.notification.showSuccess('Saved Successfully');
                // alert(this._selectedcommittee);
                this.secretarydisabled = false;
                this.permanentdisabled = false;
              }
              else {
                this.notification.showSuccess('Updated Successfully');
              }
              this.entity.Committee_Id = commiteeresult.Committee_Id;
              this.entity.reviewrDepartmentName = this.entity.DepartmentName;
            })
          }
        }
      });
      this.entity.DepartmentName = this.entity.DepartmentName;

    }
    else {
      this.saveDisabled = false;
    }
  }
  save_permanentInvitees(event: any): void {
    this.saveDisabled = true;
    if (this.entity.Response_Committee_Id) {
      this.entity.Committee_Id = this.entity.Response_Committee_Id
    }
    for (let i = 0; i < this.Inviteesarray.length; i++) {
      this.committeepermenantInviteesentity.Invitee_Id = this.Inviteesarray[i].Invitee_Id;
      this.committeepermenantInviteesentity.Emp_Ref_Id = this.Inviteesarray[i].Emp_Ref_Id;
      this.committeepermenantInviteesentity.Committee_Id = this.entity.Committee_Id;
    }
    for (let i = 0; i < this.entity.permenantInviteesgrid.length; i++) {
      this.entity.permenantInviteesgrid[i].Committee_Id = this.entity.Committee_Id;
    }
    if (this.entity.Committee_Id != '00000000-0000-0000-0000-000000000000' && this.entity.Committee_Id != null) {
      this._committeeService.saveCommitteePermenantInvitees(this.entity.permenantInviteesgrid).subscribe(() => {
        this.notification.showSuccess('Saved Successfully');

        // this.clearCommittee();

      })
    }
    this.listView = true;
    this.getAllCommittee();
    this.getAllEmployee_Chairman(this.entity.Committee_Id)
    this.saveDisabled = false;

  }


  save_member(event: any, Memberarray: any): void {
    if (this.entity.Response_Committee_Id) {
      this.entity.Committee_Id = this.entity.Response_Committee_Id
    }
    for (let i = 0; i < this.entity.committeememberarray.length; i++) {
      this.entity.committeememberarray[i].Committee_Id = this.entity.Committee_Id;
    }
    this._committeeService.savecommitteemember(this.entity.committeememberarray).subscribe(() => {
      this.notification.showSuccess('Saved Successfully');
      this.secretarydisabled = false;
      this.getAllEmployee_Chairman(this.entity.Committee_Id)
      this.chairmandisabled = false;
    })
    this.saveDisabled = false;
  }
  save_Reviewer(event: any): void {
    this.saveDisabled = true;
    for (let i = 0; i < this.Reviewerarray.length; i++) {
      this.committeeReviewerentity.Emp_Ref_Id = this.Reviewerarray[i].Emp_Ref_Id;
      this.committeeReviewerentity.Committee_Id = this.entity.Committee_Id;
      this._committeeService.saveCommitteeReviewer(this.committeeReviewerentity).subscribe(() => {
        this.notification.showSuccess('Saved Successfully');
        this.getAllEmployee_Chairman(this.entity.Committee_Id)
      })
    }
    this.saveDisabled = false;
  }
  getAllMeeting_type(filter: string) {
    this._MeetingtypeService.getAllMeetingtype(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Meetingtype>) => {
      this.Meetingtype = data;
    })
  }
  getAllDepartments(filter: string) {
    this._departmentService.getAllDepartment(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Department>) => {
      this.departments = data;
    })
  }
  getAllact(filter: string) {
    if (filter) {
      this._actservice.getAllAct(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Act>) => {
        this.actdata = data;
        return this.actdata;
      })
    }
    else {
      this._actservice.getAllAct('', this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Act>) => {
        this.actdata = data;
      })
    }

  }
  getAllInvitees(filter: string) {
    this._InviteeTypeService.getAllInviteeType(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<InviteeType>) => {
      this.Inviteetype = data;
    })
  }
  getAllEmployee(filter: string) {
    this._employeeService.getAllEmployees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((employees: Array<Employee>) => {
      this.Secratary_employees = employees;
    })
  };
  setSecretaryEmployee(employee: any): void {
    this.selectedSecretaryEmp = employee;
  }

  // setSecreataryEmployee(employee: any): void {
  //   this.selectedSecreatary = employee;
  // }
  getAllEmployee_Invitees(filter: string) {
    this._employeeService.getAllEmployees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((employees: Array<Employee>) => {
      // this.PermenantInvitees = employees;
      this.Employee_inviteedata = employees;
    })
  };
  setInviteeEmployee(employee: any): void {
    this.selectedInviteeEmp = employee;
  }
  list(event: any) {
    let dvplists: String = '';
    let dvplistsnew: String = '';
    for (let i = 0; i < this.mappingentity.Employee_inviteedata.length; i++) {
      dvplists = ",";
      dvplistsnew = dvplistsnew + this.mappingentity.Employee_inviteedata[i].EmployeeName.toString() + dvplists;
    }

  }
  getAllEmployee_member(filter: string) {
    this._employeeService.getAllEmployees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((employees_member: Array<Employee>) => {
      this.member_employees = employees_member;

    })
  };
  setMemberEmployee(employee: any): void {
    this.selectedMemberEmp = employee;
  }
  getAllEmployee_Chairman(Committee_Id?: string) {
    this._committeeService.getCommitteeMemberlistByCommitteId(this.entity.Committee_Id).subscribe((employees_Chairman: Array<committeemember>) => {
      this.Chairman_employees = employees_Chairman;
    })
  };
  setChairmanEmployee(employee: any): void {
    this.selectedChairmanEmp = employee;
  }

  getAllOrganizer(filter: string) {
    if (filter) {
      this._employeeService.getAll_Employees(filter, Number(this.defaultRowsCount), 1, 0, 0).subscribe((organizer: Array<Employee>) => {
        this.organizerdata = organizer;
        return this.organizerdata;

      })
    }
    else {
      this._employeeService.getAll_Employees('', Number(this.defaultRowsCount), 1, 0, 0).subscribe((organizer: Array<Employee>) => {
        this.organizerdata = organizer;
        return this.organizerdata;
      })
    }
  };
  getAllMultiDepartment(filter: string) {
    if (filter) {
      this._departmentService.getAllDepartment(filter, Number(this.defaultRowsCount), 1, 0, 0).subscribe((multidepartment: Array<Department>) => {
        this.multidepartmentdata = multidepartment;
        return this.multidepartmentdata;
      })
    }
    else {
      this._departmentService.getAllDepartment('', Number(this.defaultRowsCount), 1, 0, 0).subscribe((multidepartment: Array<Department>) => {
        this.multidepartmentdata = multidepartment;
        return this.multidepartmentdata;

      })
    }
  };
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllCommittee();
  }

  refreshCommittee(event: any): void {
    this.getAllCommittee();
  }

  clearCommittee(): void {
    // this._selectedcommittee = {};
    this.entity = new Committee();
    this.download="";
    this.saveDisabled = false;
  }

  onExcelExport() {
    this.excelexport.save()
  }
  onExcelExport1() {
    this.excelexport1.save()
  }
  onExcelExport2() {
    this.excelexport2.save()
  }
  onExcelExport3() {
    this.excelexport3.save()
  }
  onExcelExport4() {
    this.excelexport4.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  tenureValue(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 47 || charCode > 57) && (charCode != 46)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  fileChanged(event: any) {
    this.isDownloadButtonVisible=false;
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || event.target.files[0].type == 'application/pdf') {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          this.url = String(event.target?.result);
        }
      }
      else {
        this.notification.showWarning('Choose correct File Format');
      }
      this.entity.Document = event?.target?.files[0];

      //downloading file
      const link: any = document.getElementById('link');
      link.download = this.entity.Document.name;
      link.href = URL.createObjectURL(this.entity.Document);
      this.download=this.entity.Document.name;
    }
  }

  removeImage(event: any) {
    this.url = '';
    this.isButtonVisible = false;
    this.entity.Document = null;
  }

  goToNextTab(): void {
    if (this.aciveTab != 5) {
      this.aciveTab++;
      let element = document.getElementById('tab' + this.aciveTab);
      if (element)
        element.click();
    }
  }
  goToBackTab(): void {
    if (this.aciveTab != 1) {
      this.aciveTab--;
      let element = document.getElementById('tab' + this.aciveTab);
      if (element)
        element.click();
    }
    else {
      this.listView = true;
    }
  }
  downloadFunction(file: any): void {
    // let documentId = entity.Ref_Id;
    if(this.entity.Ref_Id!=null && this.entity.FileName!=null){
    this.documentdownloadservice.downloadFile(file) 
    }
    else{
      this.notification.showWarning('No documents found');
    }
  }

  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Committee_Id = dataItem.Committee_Id;
    this.details = [];
    this.selected_members = [];
    this.selected_Invitees = [];
    this.selected_acts = [];
    this._selectedOrganizer = [];
    this._selectedMultidept = [];
    this._committeeService.viewcommittee(this.entity.Committee_Id).subscribe((committee: Array<Committee>) => {
      this.opened = true;
      this.memberCaption = 'Member Details';
      this.PermanentCaption = 'Permanent Invitees Details';
      this.actCaption = 'Act Details';
      this.OrganizerCaption = 'Organizer Details';
      this.MultiDepartmentCaption = 'Other Department Details';
      this.details = committee;
      // this.details.SecretaryInChargeTillDate = (this.Secretaryarray.SecretaryInChargeTillDate == null && new Date(this.Secretaryarray.SecretaryInChargeTillDate).getFullYear() == 1900) ? '' : this.pipe.transform(this.Secretaryarray.SecretaryInChargeTillDate, 'dd/MM/yyyy');
      this._committeeService.getCommitteeMemberlistByCommitteId(this.entity.Committee_Id).subscribe((selected_members: Array<committeemember>) => {
        this.selected_members = selected_members;
        this._committeeService.getCommittePermanentInviteesByCommitteId(this.entity.Committee_Id).subscribe((selected_Invitees: Array<committeepermenantInvitees>) => {
          this.selected_Invitees = selected_Invitees;
          this._committeeService.getCommitteeActlistByCommitteId(this.entity.Committee_Id).subscribe((selected_acts: Array<Act>) => {
            this.selected_acts = selected_acts;
            // this._committeeService.getCommitteeOrganizerslistByCommitteId(this.entity.Committee_Id).subscribe((selected_Organizers: Array<Employee>) => {
            //   this._selectedOrganizer = selected_Organizers;
          })
        })
      })
      // });
    });
  }
}
